import { useState, useLayoutEffect } from 'react';

const getMatches = (query: string) =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? Boolean(window.matchMedia(query)?.matches)
    : false;

const useMediaQuery = (query: string) => {
  // Read synchronously on the first render: starting from `false` made every consumer render its
  // desktop variant once on mobile (mounting desktop-only children and their effects).
  const [matches, setMatches] = useState(() => getMatches(query));

  useLayoutEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [matches, query]);

  return matches;
};

export default useMediaQuery;
